// Simplified Chinese for the Atomic CRM screens. Flat keys; missing keys fall back to English.
// Deal screens are hidden in EGI Sales and stay in English.
export const chineseCrmMessagesFlat: Record<string, string> = {
  "resources.companies.name": "客户",
  "resources.companies.forcedCaseName": "客户",
  "resources.companies.fields.name": "公司名称",
  "resources.companies.fields.website": "网站",
  "resources.companies.fields.linkedin_url": "LinkedIn 链接",
  "resources.companies.fields.phone_number": "电话",
  "resources.companies.fields.created_at": "创建时间",
  "resources.companies.fields.nb_contacts": "联系人数",
  "resources.companies.fields.revenue": "营收",
  "resources.companies.fields.sector": "行业",
  "resources.companies.fields.size": "规模",
  "resources.companies.fields.tax_identifier": "税号",
  "resources.companies.fields.address": "地址",
  "resources.companies.fields.city": "城市",
  "resources.companies.fields.zipcode": "邮编",
  "resources.companies.fields.state_abbr": "州",
  "resources.companies.fields.country": "国家",
  "resources.companies.fields.description": "描述",
  "resources.companies.fields.context_links": "相关链接",
  "resources.companies.fields.sales_id": "负责人",
  "resources.companies.empty.description": "客户列表还是空的。",
  "resources.companies.empty.title": "还没有客户",
  "resources.companies.import.title": "导入客户",
  "resources.companies.field_categories.contact": "联系方式",
  "resources.companies.field_categories.additional_info": "其他信息",
  "resources.companies.field_categories.address": "地址",
  "resources.companies.field_categories.context": "背景",
  "resources.companies.action.create": "新建客户",
  "resources.companies.action.edit": "编辑客户",
  "resources.companies.action.new": "新建客户",
  "resources.companies.action.show": "查看客户",
  "resources.companies.added_on": "添加于 %{date}",
  "resources.companies.followed_by": "负责人：%{name}",
  "resources.companies.followed_by_you": "由你负责",
  "resources.companies.no_contacts": "没有联系人",
  "resources.companies.nb_contacts": "%{smart_count} 个联系人",
  "resources.companies.nb_deals": "%{smart_count} 个商机",
  "resources.companies.sizes.one_employee": "1 人",
  "resources.companies.sizes.two_to_nine_employees": "2-9 人",
  "resources.companies.sizes.ten_to_forty_nine_employees": "10-49 人",
  "resources.companies.sizes.fifty_to_two_hundred_forty_nine_employees":
    "50-249 人",
  "resources.companies.sizes.two_hundred_fifty_or_more_employees": "250 人以上",
  "resources.companies.autocomplete.create_error": "新建客户时出错",
  "resources.companies.autocomplete.create_item": "新建 %{item}",
  "resources.companies.autocomplete.create_label": "输入名称即可新建客户",
  "resources.contacts.name": "联系人",
  "resources.contacts.forcedCaseName": "联系人",
  "resources.contacts.field_categories.background_info": "背景信息",
  "resources.contacts.field_categories.identity": "基本信息",
  "resources.contacts.field_categories.misc": "其他",
  "resources.contacts.field_categories.personal_info": "联系方式",
  "resources.contacts.field_categories.position": "职位",
  "resources.contacts.fields.first_name": "名",
  "resources.contacts.fields.last_name": "姓",
  "resources.contacts.fields.last_seen": "最近联系",
  "resources.contacts.fields.title": "职位",
  "resources.contacts.fields.company_id": "公司",
  "resources.contacts.fields.email_jsonb": "邮箱",
  "resources.contacts.fields.email": "邮箱",
  "resources.contacts.fields.phone_jsonb": "电话",
  "resources.contacts.fields.phone_number": "电话",
  "resources.contacts.fields.linkedin_url": "LinkedIn 链接",
  "resources.contacts.fields.background": "背景信息（简介、怎么认识的等）",
  "resources.contacts.fields.has_newsletter": "订阅邮件",
  "resources.contacts.fields.sales_id": "负责人",
  "resources.contacts.action.add": "添加联系人",
  "resources.contacts.action.add_first": "添加第一个联系人",
  "resources.contacts.action.create": "新建联系人",
  "resources.contacts.action.edit": "编辑联系人",
  "resources.contacts.action.export_vcard": "导出 vCard",
  "resources.contacts.action.new": "新建联系人",
  "resources.contacts.action.show": "查看联系人",
  "resources.contacts.background.last_activity_on": "最近活动 %{date}",
  "resources.contacts.background.added_on": "添加于 %{date}",
  "resources.contacts.background.followed_by": "负责人：%{name}",
  "resources.contacts.background.followed_by_you": "由你负责",
  "resources.contacts.background.status_none": "无",
  "resources.contacts.position_at": "%{title}，",
  "resources.contacts.position_at_company": "%{title}，%{company}",
  "resources.contacts.empty.description": "联系人列表还是空的。",
  "resources.contacts.empty.title": "还没有联系人",
  "resources.contacts.import.title": "导入联系人",
  "resources.contacts.inputs.genders.male": "男",
  "resources.contacts.inputs.genders.female": "女",
  "resources.contacts.inputs.genders.nonbinary": "其他",
  "resources.contacts.inputs.personal_info_types.work": "工作",
  "resources.contacts.inputs.personal_info_types.home": "家庭",
  "resources.contacts.inputs.personal_info_types.other": "其他",
  "resources.contacts.list.error_loading": "加载联系人出错",
  "resources.contacts.bulk_tag.action": "加标签",
  "resources.contacts.bulk_tag.back": "返回标签",
  "resources.contacts.bulk_tag.create_description":
    "新建一个标签，并加到选中的联系人上。",
  "resources.contacts.bulk_tag.description":
    "给选中的联系人选一个已有标签，或新建一个。",
  "resources.contacts.bulk_tag.empty": "还没有标签，先新建一个。",
  "resources.contacts.bulk_tag.error": "加标签失败",
  "resources.contacts.bulk_tag.removed": "已从 %{smart_count} 个联系人移除标签",
  "resources.contacts.bulk_tag.success": "已给 %{smart_count} 个联系人加上标签",
  "resources.contacts.bulk_tag.title": "给联系人加标签",
  "resources.contacts.merge.action": "与另一个联系人合并",
  "resources.contacts.merge.confirm": "合并联系人",
  "resources.contacts.merge.current_contact": "当前联系人（将被删除）",
  "resources.contacts.merge.description": "把这个联系人合并到另一个联系人。",
  "resources.contacts.merge.error": "合并失败",
  "resources.contacts.merge.merging": "合并中...",
  "resources.contacts.merge.no_additional_data": "没有需要合并的数据",
  "resources.contacts.merge.select_target": "请选择要合并到的联系人",
  "resources.contacts.merge.success": "合并成功",
  "resources.contacts.merge.target_contact": "目标联系人（保留）",
  "resources.contacts.merge.title": "合并联系人",
  "resources.contacts.merge.warning_description":
    "所有数据会转到第二个联系人名下，无法撤销。",
  "resources.contacts.merge.warning_title": "注意：此操作不可撤销",
  "resources.contacts.merge.what_will_be_merged": "将合并的内容：",
  "resources.contacts.filters.before_last_month": "上个月以前",
  "resources.contacts.filters.before_this_month": "本月以前",
  "resources.contacts.filters.before_this_week": "本周以前",
  "resources.contacts.filters.managed_by_me": "我负责的",
  "resources.contacts.filters.search": "搜索姓名、公司...",
  "resources.contacts.filters.this_week": "本周",
  "resources.contacts.filters.today": "今天",
  "resources.contacts.filters.tags": "标签",
  "resources.contacts.filters.tasks": "任务",
  "resources.contacts.hot.empty_change_status":
    "给联系人加一条备注，点“显示选项”即可修改状态。",
  "resources.contacts.hot.empty_hint": "状态为“热”的联系人会显示在这里。",
  "resources.contacts.hot.title": "重点联系人",
  "resources.notes.name": "备注",
  "resources.notes.forcedCaseName": "备注",
  "resources.notes.fields.status": "状态",
  "resources.notes.fields.date": "日期",
  "resources.notes.fields.attachments": "附件",
  "resources.notes.fields.contact_id": "联系人",
  "resources.notes.fields.deal_id": "商机",
  "resources.notes.action.add": "添加备注",
  "resources.notes.action.add_first": "添加第一条备注",
  "resources.notes.action.delete": "删除备注",
  "resources.notes.action.edit": "编辑备注",
  "resources.notes.action.update": "更新备注",
  "resources.notes.action.add_this": "添加这条备注",
  "resources.notes.sheet.create": "新建备注",
  "resources.notes.sheet.create_for": "给 %{name} 新建备注",
  "resources.notes.sheet.edit": "编辑备注",
  "resources.notes.sheet.edit_for": "编辑 %{name} 的备注",
  "resources.notes.deleted": "备注已删除",
  "resources.notes.empty": "还没有备注",
  "resources.notes.author_added": "%{name} 添加了备注",
  "resources.notes.you_added": "你添加了备注",
  "resources.notes.me": "我",
  "resources.notes.list.error_loading": "加载备注出错",
  "resources.notes.note_for_contact": "%{name} 的备注",
  "resources.notes.stepper.hint": "进入联系人页面添加备注",
  "resources.notes.added": "备注已添加",
  "resources.notes.inputs.add_note": "添加备注",
  "resources.notes.inputs.options_hint": "（添加附件或修改详情）",
  "resources.notes.inputs.show_options": "显示选项",
  "resources.notes.actions.attach_document": "添加附件",
  "resources.notes.validation.note_or_attachment_required":
    "请填写备注或添加附件",
  "resources.sales.name": "用户",
  "resources.sales.fields.first_name": "名",
  "resources.sales.fields.last_name": "姓",
  "resources.sales.fields.email": "邮箱",
  "resources.sales.fields.secondary_email": "备用邮箱",
  "resources.sales.fields.secondary_emails": "备用邮箱",
  "resources.sales.fields.administrator": "管理员",
  "resources.sales.fields.disabled": "已停用",
  "resources.sales.create.error": "创建用户时出错。",
  "resources.sales.create.success":
    "用户已创建。点他后面的“复制登录链接”，用 WhatsApp 或微信发给他。",
  "resources.sales.create.title": "新建用户",
  "resources.sales.edit.error": "出错了，请重试。",
  "resources.sales.edit.record_not_found": "找不到这条记录",
  "resources.sales.edit.success": "用户已更新",
  "resources.sales.edit.title": "编辑 %{name}",
  "resources.sales.action.new": "新建用户",
  "resources.tasks.name": "任务",
  "resources.tasks.forcedCaseName": "任务",
  "resources.tasks.fields.text": "内容",
  "resources.tasks.fields.due_date": "截止日期",
  "resources.tasks.fields.type": "类型",
  "resources.tasks.fields.contact_id": "联系人",
  "resources.tasks.fields.due_short": "截止",
  "resources.tasks.action.add": "添加任务",
  "resources.tasks.action.create": "新建任务",
  "resources.tasks.action.edit": "编辑任务",
  "resources.tasks.actions.postpone_next_week": "推迟到下周",
  "resources.tasks.actions.postpone_tomorrow": "推迟到明天",
  "resources.tasks.actions.title": "任务操作",
  "resources.tasks.added": "任务已添加",
  "resources.tasks.deleted": "任务已删除",
  "resources.tasks.dialog.create": "新建任务",
  "resources.tasks.dialog.create_for": "给 %{name} 新建任务",
  "resources.tasks.sheet.edit": "编辑任务",
  "resources.tasks.sheet.edit_for": "编辑 %{name} 的任务",
  "resources.tasks.empty": "还没有任务",
  "resources.tasks.empty_list_hint": "给联系人添加的任务会显示在这里。",
  "resources.tasks.filters.later": "以后",
  "resources.tasks.filters.overdue": "已逾期",
  "resources.tasks.filters.this_week": "本周",
  "resources.tasks.filters.today": "今天",
  "resources.tasks.filters.tomorrow": "明天",
  "resources.tasks.filters.with_pending": "有未完成任务",
  "resources.tasks.regarding_contact": "（关于 %{name}）",
  "resources.tasks.updated": "任务已更新",
  "resources.tags.name": "标签",
  "resources.tags.action.add": "添加标签",
  "resources.tags.action.create": "新建标签",
  "resources.tags.dialog.color": "颜色",
  "resources.tags.dialog.create_title": "新建标签",
  "resources.tags.dialog.edit_title": "编辑标签",
  "resources.tags.dialog.name_label": "标签名",
  "resources.tags.dialog.name_placeholder": "输入标签名",
  "resources.tags.empty": "还没有标签。",
  "crm.action.reset_password": "重置密码",
  "crm.auth.first_name": "名",
  "crm.auth.last_name": "姓",
  "crm.auth.confirm_password": "确认密码",
  "crm.auth.confirmation_required": "请点击邮件里的链接确认你的账号。",
  "crm.auth.recovery_email_sent": "请找管理员要一条登录链接来重置密码。",
  "crm.auth.sign_in_failed": "登录失败。",
  "crm.auth.sign_in_google_workspace": "用 Google Workspace 登录",
  "crm.auth.signup.create_account": "创建账号",
  "crm.auth.signup.create_first_user": "创建第一个用户账号，完成初始设置。",
  "crm.auth.signup.creating": "创建中...",
  "crm.auth.signup.initial_user_created": "第一个用户已创建",
  "crm.auth.welcome_title": "欢迎使用 EGI Sales",
  "crm.common.account_manager": "负责人",
  "crm.common.activity": "动态",
  "crm.common.added": "添加了",
  "crm.common.details": "详情",
  "crm.common.last_activity_with_date": "最近活动 %{date}",
  "crm.common.load_more": "加载更多",
  "crm.common.misc": "其他",
  "crm.common.past": "过去",
  "crm.common.read_more": "展开",
  "crm.common.retry": "重试",
  "crm.common.show_less": "收起",
  "crm.common.copied": "已复制！",
  "crm.common.copy": "复制",
  "crm.common.loading": "加载中...",
  "crm.common.me": "我",
  "crm.common.task_count": "%{smart_count} 个任务",
  "crm.changelog.title": "更新日志",
  "crm.activity.added_company": "%{name} 添加了客户",
  "crm.activity.you_added_company": "你添加了客户",
  "crm.activity.added_contact": "%{name} 添加了",
  "crm.activity.you_added_contact": "你添加了",
  "crm.activity.added_note": "%{name} 添加了备注：",
  "crm.activity.you_added_note": "你添加了备注：",
  "crm.activity.at_company": "，公司",
  "crm.activity.to": "到",
  "crm.activity.load_more": "加载更多动态",
  "crm.dashboard.latest_activity": "最新动态",
  "crm.dashboard.latest_activity_error": "加载最新动态出错",
  "crm.dashboard.latest_notes": "我的最新备注",
  "crm.dashboard.latest_notes_added_ago": "%{timeAgo}添加",
  "crm.dashboard.stepper.progress": "已完成 %{step}/3",
  "crm.dashboard.stepper.whats_next": "下一步",
  "crm.dashboard.upcoming_tasks": "待办任务",
  "crm.data_import.button": "导入 CSV",
  "crm.data_import.complete":
    "导入完成。成功 %{importCount} 条，出错 %{errorCount} 条",
  "crm.data_import.csv_file": "CSV 文件",
  "crm.data_import.error": "导入失败，请确认是有效的 CSV 文件。",
  "crm.data_import.in_progress": "导入中…",
  "crm.data_import.progress":
    "已导入 %{importCount} / %{rowCount} 条，出错 %{errorCount} 条。",
  "crm.data_import.remaining_time": "预计剩余时间：",
  "crm.data_import.resource": "数据类型",
  "crm.data_import.sample_download": "下载 CSV 样例",
  "crm.data_import.sample_hint": "可以照这个样例 CSV 填写",
  "crm.data_import.start": "开始导入",
  "crm.data_import.stop": "停止导入",
  "crm.data_import.stopped":
    "导入已停止。成功 %{importCount} 条，出错 %{errorCount} 条",
  "crm.data_import.title": "导入数据",
  "crm.header.import_data": "从 JSON 导入",
  "crm.search.title": "搜索",
  "crm.search.placeholder": "搜索联系人、客户、任务和备注...",
  "crm.search.hint": "至少输入 %{min} 个字符",
  "crm.search.empty": "没有找到结果",
  "crm.search.error": "搜索暂时不可用，请稍后再试。",
  "crm.search.untitled_result": "（无标题）",
  "crm.search.groups.contacts": "联系人",
  "crm.search.groups.companies": "客户",
  "crm.search.groups.tasks": "任务",
  "crm.search.groups.contact_notes": "联系人备注",
  "crm.image_editor.change": "更换",
  "crm.image_editor.drop_hint": "把文件拖到这里，或点击选择。",
  "crm.image_editor.editable_content": "可编辑内容",
  "crm.image_editor.title": "上传并裁剪图片",
  "crm.image_editor.update_image": "更新图片",
  "crm.import.action.download_error_report": "下载错误报告",
  "crm.import.action.import": "导入",
  "crm.import.action.import_another": "导入另一个文件",
  "crm.import.error.unable": "无法导入这个文件。",
  "crm.import.idle.description_1": "可以导入用户、客户、联系人、备注和任务。",
  "crm.import.idle.description_2": "数据须是符合以下样例格式的 JSON 文件：",
  "crm.import.status.all_success": "全部导入成功。",
  "crm.import.status.complete": "导入完成。",
  "crm.import.status.failed": "失败",
  "crm.import.status.imported": "已导入",
  "crm.import.status.in_progress": "导入中，请不要离开此页面。",
  "crm.import.status.some_failed": "部分记录没有导入。",
  "crm.import.status.table_caption": "导入状态",
  "crm.import.title": "从 JSON 导入",
  "crm.settings.about": "关于",
  "crm.settings.companies.sectors": "行业",
  "crm.settings.dark_mode_logo": "深色模式 Logo",
  "crm.settings.light_mode_logo": "浅色模式 Logo",
  "crm.settings.notes.statuses": "状态",
  "crm.settings.reset_defaults": "恢复默认",
  "crm.settings.save_error": "保存设置失败",
  "crm.settings.saved": "设置已保存",
  "crm.settings.saving": "保存中...",
  "crm.settings.tasks.types": "类型",
  "crm.settings.preferences": "偏好设置",
  "crm.settings.title": "设置",
  "crm.settings.app_title": "系统名称",
  "crm.settings.sections.branding": "品牌",
  "crm.settings.validation.duplicate": "%{display_name}重复：%{items}",
  "crm.settings.validation.validating": "校验中…",
  "crm.theme.dark": "深色",
  "crm.theme.label": "主题",
  "crm.theme.light": "浅色",
  "crm.theme.system": "跟随系统",
  "crm.language": "语言",
  "crm.navigation.label": "导航",
  "crm.profile.add_secondary_email": "添加邮箱",
  "crm.profile.email_taken": "%{email} 已被其他用户使用",
  "crm.profile.no_secondary_emails": "无",
  "crm.profile.secondary_email_invalid": "%{email} 不是有效的邮箱",
  "crm.profile.secondary_email_is_primary": "%{email} 已经是你的主邮箱",
  "crm.profile.secondary_email_taken": "%{email} 已被其他用户使用",
  "crm.profile.too_many_secondary_emails": "备用邮箱最多 10 个",
  "crm.profile.secondary_emails_help": "你常用来发邮件的其他地址。留空即删除。",
  "crm.profile.password.change": "修改密码",
  "crm.profile.password_reset_sent": "重置密码邮件已发送",
  "crm.profile.record_not_found": "找不到这条记录",
  "crm.profile.title": "个人资料",
  "crm.profile.updated": "个人资料已更新",
  "crm.profile.update_error": "出错了，请重试",
  "crm.validation.invalid_url": "请输入有效网址",
  "crm.validation.invalid_linkedin_url": "必须是 linkedin.com 的链接",
};
